/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_Q6Inputs */

const en_fc_home_faq_q6 = /** @type {(inputs: Fc_Home_Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which systems does it run on?`)
};

/**
* | output |
* | --- |
* | "Which systems does it run on?" |
*
* @param {Fc_Home_Faq_Q6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_q6 = /** @type {((inputs?: Fc_Home_Faq_Q6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_Q6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_q6(inputs)
});
export { fc_home_faq_q6 as "fc.home.faq.q6" }